export interface DropdownItem {
  src?: string
  label: string
  value: string
  supportedCurrencies: [string]
}
